import { useState } from "react";
import { lazy, Suspense } from 'react';
import extrasImage from "../imagenes/extras-160-160.webp";
import chickenKatsuBox from '../imagenes/chickenKatsuBox-160-160.webp';
import cornDogs from '../imagenes/cornDogs-160-160.webp'
import { motion } from "framer-motion";
import { useInView } from 'react-intersection-observer';

// import { analytics } from "../firebase/config.js";
// import { logEvent } from "firebase/analytics";
import combo1 from "../imagenes/combo1-160-140.webp";
import combo2 from "../imagenes/combo2-160-140.webp";
import ramenClasico from '../imagenes/ramenClasico-160-160.webp';
import sojus from '../imagenes/sojus.webp'
import Sopas from "./menu/Sopas.js";
import Obentos from "./menu/Obentos.js";
import Bebidas from "./menu/Bebidas.js";
import Extras from "./menu/Extras.js";
// import Corndogs from "./menu/Corndogs.js";
const LazyCorndogs = lazy(() => import('./menu/Corndogs.js'));

function Menu() {
  const [sopasRamen, setSopasRamen] = useState(false);
  const [cornDogsState, setCornDogs] = useState(false);
  const [obentos, setObentos] = useState(false);
  const [bebidas, setBebidas] = useState(false);
  const [extras, setExtras] = useState(false);
  const { ref, inView } = useInView({ triggerOnce: true });

  const handleSopasRamen = ()=>{
    setSopasRamen(true);
    setCornDogs(false);
    setObentos(false);
    setBebidas(false);
    setExtras(false);
    // logEvent(analytics, "click_ver_completo", {
    //   category: "Sopas Ramen",
    // });
  }
  const handleCornDogs = ()=>{
    setCornDogs(true);
    setSopasRamen(false);
    setObentos(false);
    setBebidas(false);
    setExtras(false);
    // logEvent(analytics, "click_ver_completo", {
    //   category: "Corn Dogs",
    // });
  }
  const handleObentos = ()=>{
    setObentos(true);
    setCornDogs(false);
    setSopasRamen(false);
    setBebidas(false);
    setExtras(false);
    // logEvent(analytics, "click_ver_completo", {
    //   category: "Obentos",
    // });
  }
  const handleBebidas = ()=>{
    setBebidas(true);
    setObentos(false);
    setCornDogs(false);
    setSopasRamen(false);
    setExtras(false);
    // logEvent(analytics, "click_ver_completo", {
    //   category: "Bebidas",
    // });
  }
  const handleExtras =()=>{
    setExtras(true);
    setBebidas(false);
    setObentos(false);
    setCornDogs(false);
    setSopasRamen(false);
    // logEvent(analytics, "click_ver_completo", {
    //   category: "Extras",
    // });
  }


  
  return (
    <section className=" bg-[#FFD1DC]" id="menu">
      <div className="min-h-screen w-full flex flex-col text-center gap-4 items-center justify-center py-20">
        
        <motion.h3
          initial={{ y: -100, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 1.5 }}
          className="text-5xl text-rojizo"
        >
          Revisa nuestras categorias
        </motion.h3>
        <div className="flex gap-10 max-[800px]:flex-col">
          <motion.div
            initial={{ x: -50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.3 }}
            className=" w-[270px] h-[400px] bg-white border-2 border-rosa flex flex-col items-center justify-center rounded-3xl gap-4"
          >
            <div className="w-[190px] h-[190px] bg-[#971423] rounded-full flex items-center justify-center">
              <img
                src={ramenClasico}
                alt="sopa ramen de KoreanMania"
                loading="lazy"
                width={160}
                height={160}
              />
            </div>
            <h2 className="text-xl border-b-2 border-rosa">SOPAS RAMEN</h2>
            <p className="text-sm w-4/5 text-marron">
            Fideos japoneses en caldo artesanal, acompañados de proteínas y toppings únicos.
            </p>
            <a href="#sopas">
              <button
                onClick={handleSopasRamen}
                className="bg-rojizo text-white p-2 px-4 rounded-lg hover:bg-green-800"
              >
                Ver completo
              </button>
            </a>
          </motion.div>
          <motion.div
            initial={{ x: -50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.3, delay: 0.3 }}
            className=" w-[270px] h-[400px] bg-white border-2 border-rosa flex flex-col items-center justify-center rounded-3xl gap-4"
          >
            <div className="w-[190px] h-[190px] bg-[#971423]  rounded-full flex items-center justify-center">
              <img
                src={cornDogs}
                loading="lazy"
                alt="Corn Dogs de KoreanMania"
                width={160}
                height={160}
              />
            </div>
            <h2 className=" text-xl border-b-2 border-rosa">CORN DOGS</h2>
            <p className="text-sm w-4/5 text-marron">
            Salchichas empanizadas al estilo coreano, crujientes por fuera y suaves por dentro.
            </p>
            <a href="#corndogs">
              <button
                onClick={handleCornDogs}
                className="bg-rojizo text-white p-2 px-4 rounded-lg hover:bg-green-800"
              >
                Ver completo
              </button>
            </a>
          </motion.div>
          <motion.div
            initial={{ x: -50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.3, delay: 0.6 }}
            className=" w-[270px] h-[400px] bg-white border-2 border-rosa flex flex-col items-center justify-center rounded-3xl gap-4"
          >
            <div className="w-[190px] h-[190px] bg-[#971423] rounded-full flex items-center justify-center">
              <img
                src={chickenKatsuBox}
                alt="chicken katsu box de KoreanMania"
                loading="lazy"
                width={160}
                height={160}
              />
            </div>
            <h2 className="text-xl border-b-2 border-rosa">OBENTOS</h2>
            <p className="text-sm w-4/5 text-marron">
            Cajas japonesas con porciones balanceadas de arroz, proteínas y vegetales.
            </p>
            <a href="#obentos">
              <button
                onClick={handleObentos}
                className="bg-rojizo text-white p-2 px-4 rounded-lg hover:bg-green-800"
              >
                Ver completo
              </button>
            </a>
          </motion.div>
          
        </div>

      {/* seccion inferior */}

        <div className="flex gap-10 max-[800px]:flex-col pt-6">
          <motion.div 
          initial={{x:-50, opacity:0}}
          whileInView={{x:0, opacity:1}}
          transition={{duration:0.3}}
          className=" w-[270px] h-[400px] bg-white border-2 border-rosa flex flex-col items-center justify-center rounded-3xl gap-4">
            <div className="w-[190px] h-[190px] bg-[#971423]  rounded-full flex items-center justify-center">
              <img
                src={sojus}
                loading="lazy"
                alt="helados coreanos"
                width={160}
                height={160}
              />
            </div>
            <h2 className=" text-xl border-b-2 border-rosa">BEBIDAS</h2>
            <p className="text-sm w-4/5 text-marron">
            Refrescos asiáticos y opciones tradicionales para acompañar tu comida.
            </p>
            <a href="#bebidas">
              <button
                onClick={handleBebidas}
                className="bg-rojizo text-white p-2 px-4 rounded-lg hover:bg-green-800"
              >
                Ver completo
              </button>
            </a>
          </motion.div>
          <motion.div 
          initial={{x:-50, opacity:0}}
          whileInView={{x:0, opacity:1}}
          transition={{duration:0.3, delay:0.3}}
          className=" w-[270px] h-[400px] bg-white border-2 border-rosa flex flex-col items-center justify-center rounded-3xl gap-4">
            <div className="w-[190px] h-[190px] bg-[#971423]  rounded-full flex items-center justify-center">
              <img
                src={extrasImage}
                alt="pollo coreano y onigiri"
                width={160}
                height={160}
              />
            </div>
            <h2 className=" text-xl border-b-2 border-rosa">EXTRAS</h2>
            <p className="text-sm w-4/5 text-marron">
            Onigiris artesanales, pollo coreano crocante y bombas de queso irresistibles.
            </p>
            <a href="#extras">
              <button
                onClick={handleExtras}
                className="bg-rojizo text-white p-2 px-4 rounded-lg hover:bg-green-800"
              >
                Ver completo
              </button>
            </a>
          </motion.div>
        </div>

    {/* PROMOCIONES */}

        <motion.div
          initial={{ scale: 0.5 }}
          whileInView={{ scale: 1 }}
          transition={{ duration: 0.5 }}
          className="w-[890px] max-[800px]:w-[270px] border-2 border-rosa max-[800px]:h-auto mt-6 bg-white h-[300px]  rounded-3xl flex flex-col items-center justify-center gap-6 py-4"
        >
          <h3 className="text-rojizo text-3xl font-bold pt-2">PROMOCIONES</h3>
          <div className=" flex max-[800px]:flex-col">
            <div className="w-[430px] flex items-center justify-center max-[800px]:flex-col gap-6 ">
              <img
                src={combo1}
                width={160}
                height={140}
                loading="lazy"
                alt="combo 1 de KorenaMania"
              />
              <div className="flex flex-col">
                <h4 className="text-xl pb-2 text-red-700 font-semibold">
                  Combo 1
                </h4>
                <span>Mini Corn Dog Clásico</span>
                <span>+</span>
                <span>Mini sopa Ramen Clásica</span>
                <span>+</span>
                <span>Café o vaso de gaseosa</span>
                <span className="text-end text-red-700 text-xl font-semibold">
                  s/ 18.
                </span>
              </div>
            </div>
            <div className="w-[430px]">
              <div className="w-[430px] flex items-center justify-center max-[800px]:flex-col gap-6 ">
                <img
                  src={combo2}
                  width={160}
                  height={140}
                  loading="lazy"
                  alt="combo 2 de KorenaMania"
                />
                <div className="flex flex-col">
                  <h4 className="text-xl pb-2 text-red-700 font-semibold">
                    Combo 2
                  </h4>
                  <span>2 piezas de Pollo frito</span>
                  <span>+</span>
                  <span>Mini sopa Ramen</span>
                  <span>(tonkitsu, miso ó clásico)</span>
                  <span>+</span>
                  <span>Café o vaso de gaseosa</span>
                  <span className="text-end text-red-700 text-xl font-bold">
                    s/ 22.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
      {sopasRamen && <Sopas/>}
      {cornDogsState &&<div ref={ref} id="corndogs">
      {inView && (
        <Suspense fallback={<div>Cargando...</div>}>
          <LazyCorndogs />
        </Suspense>
      )}
    </div>}
      {obentos && <Obentos/>}
      {bebidas && <Bebidas/>}
      {extras && <Extras/>}
    </section>
  );
}

export default Menu;
